// Simple language switcher component that handles initialization internally
export default defineNuxtPlugin(() => {
  // This plugin just ensures the language switcher works
  // without calling composables that might not be ready

  if (process.client) {
    // Simple client-side initialization
  }
})
